import MuiDialogTitle, { DialogTitleProps as MuiDialogTitleProps } from '@mui/material/DialogTitle';

import * as React from 'react';

import { DialogVariant, getColorsForVariant } from '_lib/featureComponents/DialogWrapper/DialogWrapper';
import { toSxArray } from '_lib/utils/helpers';

export interface DialogTitleProps extends Omit<MuiDialogTitleProps, 'variant'> {
  variant?: DialogVariant;
}

export const DialogTitle = (props: DialogTitleProps) => {
  const { variant, sx, ...restProps } = props;

  return (
    <MuiDialogTitle
      {...restProps}
      sx={[
        { textTransform: 'uppercase', paddingX: 1.5, paddingY: 1 },
        (theme) => getColorsForVariant(theme, variant),
        ...toSxArray(sx)
      ]}
    />
  );
};
